import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import { actionIconStyle as actionIcons } from '../style/ThemeProvider/commonStyles'; // TODO modify this component

/** NOTES ISSUE with Tooltip and error message
 * A disabled element does not fire events. Tooltip needs to listen to
  the child elements events to display the title but adding a span bring JSX children tooltip error. */

/**
 *
 *
 * @component
 * Icon button with tooltip
 *
 * className gets passed to the IconButton component
 */
export const ActionIcon = withStyles({
  root: actionIcons,
  navIcon: props => ({
    height: props.height || '20px'
  })
})((_ref) => {
  let {
    classes,
    title,
    tooltipProps,
    iconProps = {
      className: ''
    },
    Icon,
    className,
    htmlColor,
    style,
    disabled
  } = _ref,
      props = _objectWithoutProperties(_ref, ["classes", "title", "tooltipProps", "iconProps", "Icon", "className", "htmlColor", "style", "disabled"]);

  return title ? /*#__PURE__*/React.createElement(Tooltip, _extends({
    className: "tooltip",
    title: title
  }, tooltipProps), /*#__PURE__*/React.createElement(IconButton, _extends({
    disabled: disabled,
    classes: {
      root: classes.root
    },
    style: style,
    className: className,
    color: "primary"
  }, props), /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
    htmlColor: htmlColor,
    className: `${classes.navIcon} ${iconProps.className}`
  })))) : /*#__PURE__*/React.createElement(IconButton, _extends({
    disabled: disabled,
    classes: {
      root: classes.root
    },
    style: style,
    className: className,
    color: "primary"
  }, props), /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
    htmlColor: htmlColor,
    className: `${classes.navIcon} ${iconProps.className}`
  })));
});